import type { FactorCard } from "../types/api";

// Plain-buyer definition surfaced wherever the Valuation tile shows an AVM
// figure. Kept in sync with the requirements.md glossary entry for "AVM".
const AVM_DEFINITION =
  "AVM (Automated Valuation Model): a data-driven estimate of market value " +
  "from comparable sales, public records, and market trends — an estimate, " +
  "not a formal appraisal.";

/** Small hover/focus info tooltip (no deps). */
function InfoTip({ label, text }: { label: string; text: string }) {
  return (
    <span className="info-tip" tabIndex={0} role="note" aria-label={`${label}: ${text}`}>
      <span className="info-tip-icon" aria-hidden>
        ⓘ
      </span>
      <span className="info-tip-bubble" aria-hidden>
        {text}
      </span>
    </span>
  );
}

// NOTE: the old `ScoreResult` component (a single 0-100 "tilt number" headline)
// was removed 2026-07-02 with the Tilt Score retirement — the live Pro surface
// is `ProScorePanel` (Tilt Map + offer range). Only the factor card is reused.
export function FactorCardView({ factor }: { factor: FactorCard }) {
  // The Valuation group surfaces the AVM figure — explain the term inline.
  const showsAvm = /valuation/i.test(factor.name);
  return (
    <div className={`factor-card direction-${factor.direction}`}>
      <h4>
        {factor.name}
        {showsAvm && <InfoTip label="AVM" text={AVM_DEFINITION} />}
      </h4>
      <p className="direction-label">{factor.direction_label}</p>
      {factor.facts.length > 0 && (
        <ul className="facts">
          {factor.facts.map((fact, i) => (
            <li key={i}>{fact}</li>
          ))}
        </ul>
      )}
      <p className="summary">{factor.summary}</p>
    </div>
  );
}
